import BasicText from "../../BasicText";
import LButton from "../../LButton";
import Subtitle from "../../Subtitle";
import Title from "../../Title";
import WhyLuminodeFrame from "../../pages/home/WhyLuminodeFrame";
import FancyCross from "../../svg/FancyCross";
import MissionFrame from "../../svg/MissionFrame";
import globe from '@/assets/images/ASCII/globe.png';
import star from '@/assets/images/ASCII/Group 144.png';
import atom from '@/assets/images/ASCII/Group 184.png';
import zhonyas from '@/assets/images/ASCII/Group 201.png';
import AsciiArt from "../../AsciiArt";
import BigEllipse from "../../svg/ellipse/BigEllipse";
import DotEffect from "../../svg/DotEffect";

function WhyLuminode({ref0}:any) {
  return (
    <div ref={ref0} className="w-full xl:w-[1200px] px-4 sm:px-10 md:px-11 lg:px-12 xl:px-0 flex flex-col justify-start items-start gap-[10px] relative z-20 h-[1100px] xl:h-[820px]">
      <Subtitle>
        // why luminode
      </Subtitle>
      <Title className='text-[36px]'>
        <div>
          Why Luminode
        </div>
        <div className="flex flex-row">
          is&nbsp;
          <div className="text-luminode-blue">
            different
          </div>
        </div>
      </Title>
      <div className="pt-[10px]">
        <BasicText color="faded" className='text-[18px]'>
          <div className="max-w-[500px]">We have the skill to create new experiences,
          the speed to execute quickly, and the experience
          to do it efficiently.</div>
        </BasicText>
      </div>
      <div className="pt-[30px] z-50 mb-16 xl:mb-0">
        <LButton luminodeicon push_down>
          Past Work
        </LButton>
      </div>

      <div className="absolute left-[100px] top-[-70px] pointer-events-none">
        <BigEllipse />
      </div>
      <div className="absolute left-[300px] top-[300px] pointer-events-none">
        <DotEffect />
      </div>

      <div className="absolute top-[400px] xl:top-[65px] w-full h-[750px] z-10 contents xl:flex flex-col">
          <div className="flex flex-row justify-end w-full h-[33%] relative right-[2px] top-[2.5px]">
            <WhyLuminodeFrame title='Experience' subtitle='// 01' text='With multi cycle experience, Luminode Labs can handle projects from MVPs to Enterprise level solutions.'>
              <AsciiArt src={globe} />
            </WhyLuminodeFrame>
          </div>
          <div className="flex flex-row justify-end w-full h-[33%] relative right-[1px]">
            <WhyLuminodeFrame title='Macro' subtitle='// 02' text='Our unique perspective on the market gives us an advantage against other development studios that are nearly as active on-chain.'>
              <AsciiArt src={star} />
            </WhyLuminodeFrame>
            <div className="w-[0%] xl:w-[33%] h-full"></div>
          </div>
          <div className="flex flex-row justify-end w-full h-[33%] relative top-[-2.5px] gap-1 xl:gap-0">
            <WhyLuminodeFrame title='Network' subtitle='// 03' text='By merging global web2 companies and leaders with leading web3 protocols and ideals, we are able to actualize our thesis of scaling the blockchain across internet.'>
              <AsciiArt src={atom} />
            </WhyLuminodeFrame>
            <div className="w-[0%] xl:w-[33%] h-full"></div>
            <WhyLuminodeFrame title='Speed' subtitle='// 04' text='While maintaining a focus on quality, we double down on efficiency by constantly applying Agile Methodology to all of our DevOps.'>
              <AsciiArt src={zhonyas} />
            </WhyLuminodeFrame>
          </div>
      </div>
    </div>
  );
}

export default WhyLuminode;